<template>
  <section id="home-section" class="flex flex-stretch">
    <img class="logo" src="https://dyuzi43ld6cwm.cloudfront.net/luxe/img/fr/logo-big-transparent.png" alt="Campings.Luxe" />
    <div class="left-panel">
      <div class="welcome" v-html="$resx('HomeTitleText')" ></div>
      <div v-if="partner.currentCamping===null">
        <span class="group-msg">{{$resx('HomeConnectedAccountText',[partner.name])}}</span>
        <button id="btn-choose-camping" @click="showChooseCampingModal=true" class="btn btn-primary">{{$resx('HomeChooseCampsiteText')}}</button>
      </div>
      <app-menu v-if="partner.currentCamping!==null"></app-menu>
    </div>
    <div class="right-panel">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 222 284">
        <path d="M5875,215L5764,317.505,5653,215l86.84,142L5653,499l111-102.507L5875,499l-86.85-142Z" transform="translate(-5653 -215)" />
      </svg>
    </div>
    <select-campsite v-if="partner.isGroup" :show.sync="showChooseCampingModal"></select-campsite>
  </section>
</template>
<script>
import selectCampsite from '../components/selectCampsite.vue'
import menu from '../components/menu.vue'

export default {
  data () {
    return {
      showChooseCampingModal: false
    }
  },
  computed: {
    // compte partenaire connecté
    partner () {
      return this.$store.state.partner.account
    }
  },
  components:
  {
    'select-campsite': selectCampsite,
    'app-menu': menu
  },
  created: function () {
    console.log('home created')
  },
  mounted: function () {
    this.$store.commit('app/setPage', 'home')
  }
}
</script>

<style lang="less">
  @import '../assets/variables.less';

  #home-section {
    width: 100%;
    min-height:100vh;

    .logo
    {
      position:absolute;
      left:20px;
      top:40px;
      max-width:50vw;
    }

    .left-panel
    {
      padding-left: 80px;
      padding-right:20px;
    }

  .welcome {
    margin-top: 15vh;
    h2
      {
        font-weight: @fontBold;
        font-size: 2.2em;
        display: inline-block;
        margin-bottom: 0;
      }

      b {
        font-weight: @fontBlack;
        font-size: 1.5em;
        color: @gold;
      }

      span {
        display: block;
        font-weight: @fontLight;
      }
    }

    .group-msg {
      display: block;
      font-weight: @fontBold;
      font-size: 2.2em;
      margin: 1em 0;
    }

    #btn-choose-camping {
      max-width: 20em;
    }

    .menu
    {
      .title {
        font-size: 3em;
        margin-top: 1.5em;
      }

      li
      {
        opacity:1;
      }
    }
  }

  @media only screen and (min-width: 64em) {
    #home-section {
      .left-panel
      {
        width: 75%;
      }

      .right-panel {
        position: relative;
        background-image: url('https://res.cloudinary.com/luxe/image/upload/c_scale,w_500/v1537345051/partner/cover.jpg');
        background-repeat: no-repeat;
        background-position: 70% center;
        background-size: cover;
        width: 25%;

      svg
      {
        position: absolute;
        left: 40%;
        top: 35%;
        fill: #fff;
        opacity: 0.5;
        transform: translate(-50%,-50%);
        width: 40%;
      }
      }
    }
  }

  @media only screen and (min-width: 80em) {
    #home-section {
      .logo
      {
        left:80px;
      }

      .left-panel
      {
        width: 70%;
        padding-right: 80px;
      }

      .right-panel {
        background-image: url('https://res.cloudinary.com/luxe/image/upload/c_scale,w_700/v1537345051/partner/cover.jpg');
        background-position-x: 85%;
        width: 30%;
      }
    }
  }

  @media only screen and (min-width: 100em) {
    #home-section {
      .right-panel
      {
        background-image: url('https://res.cloudinary.com/luxe/image/upload/c_scale,w_1000/v1537345051/partner/cover.jpg');
        background-position-x: 100%;
      }
    }
  }
</style>
